import z from 'zod';

import { socialApiClient } from '@/shared/api-client/social-api-client';

import { searchModeMessageResponseSchema, type SearchModeMessageResponse } from '../discovery-schema';

export const createSearchModeMessageRequestSchema = z.object({
  message_id: z.string(),
});

export type CreateSearchModeMessageRequest = z.infer<typeof createSearchModeMessageRequestSchema>;

export async function createSearchModeMessage(
  discoverySessionId: string,
  request: CreateSearchModeMessageRequest,
  signal?: AbortSignal,
): Promise<SearchModeMessageResponse> {
  const parsedRequest = createSearchModeMessageRequestSchema.parse(request);
  const response = await socialApiClient.post(
    `discovery-sessions/${discoverySessionId}/search-mode-message`,
    {
      json: parsedRequest,
      signal,
    },
  );

  return searchModeMessageResponseSchema.parse(await response.json());
}
